
import Vue from "vue";
import VButton from "@/components/common/button.vue";

export default Vue.extend({
  name: "component-first-access-search",
  components: { VButton },
  methods: {
    searchClicked() {
      this.$emit("first-search-clicked");
    },
  },
});
